export default __webpack_public_path__ + "static/media/github_logo.aebd17f2.svg";